<template>

  <section class="dashboard">
    <DashboardTitle
      title="Panel de Inversiones"
      description="Aquí podrás encontrar toda la información de tus
        inversiones realizadas en Ekscelenko a través de nuestra plataforma.">
    </DashboardTitle>
    <transition name="fade" mode="out-in">
      <Preloader v-if="!viewIsReady"></Preloader>
      <div v-if="viewIsReady">
        <DashboardBalanceResume></DashboardBalanceResume>
        <DashboardInvestmentTable
          :investmentList="investmentList" v-if="!emptyInvestments" />
      </div>
    </transition>
      <transition name="fade" mode="out-in">
      <div class="box-no-investments -centered-info"
        v-if="emptyInvestments">
        <h4 class="maintitle">No tienes inversiones</h4>
<!--
        <router-link class="button" :to="{ name: 'Home' }">
          Revisa las oportunidades de inversión activas
        </router-link>
-->
      </div>
    </transition>
  </section>

</template>

<script>

import DashboardTitle from '@/components/SignedTitle'
import DashboardBalanceResume from '@/components/DashboardBalanceResume'
import DashboardInvestmentTable
  from '@/views/dashboardInvestment/DashboardInvestmentTable'
import Preloader from '@/components/Preloader'

import httpRequestMixin from '@/mixins/httpRequestMixin'

export default {
  name: 'DashboardInvestment',
  metaInfo () {
    return {
      title: 'Panel de Inversiones'
    }
  },
  components: {
    Preloader,
    DashboardTitle,
    DashboardBalanceResume,
    DashboardInvestmentTable
  },
  mixins: [httpRequestMixin],
  data () {
    return {
      balance: {
        balance: 0,
        activeInvestments: 0,
        averageRate: 0
      },
      investmentList: [],
      emptyInvestments: false,
      viewIsReady: false
    }
  },
  created: async function () {
    this.getInvestments()
  },
  methods: {
    getInvestments: async function () {
      let options = {
        method: 'GET',
        url: this.checkProtocol(process.env.AUTH_BASE + '/investments/'),
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        params: {
          limit: 10
        }
      }
      const response = await this.httpRequest(options)
      if (response) {
        if (response.status === 200) {
          this.viewIsReady = true
          this.investmentList = response.data
          if (this.investmentList.count === 0) {
            this.emptyInvestments = true
          }
        }
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/views/DashboardInvestment.vue